import { ReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { Logger } from '@/domain/app';

import {
    getApplePayCardNativeState,
    getApplePayCardNativeStateKb,
} from '@domain/digital-wallet/utils/get-apple-pay-status';

import { ApplePayKbCardData, ApplePayTeCardData } from '../components/apple-pay/ApplePayContent';

type ApplePayCardStaus = {
    canOnboard: boolean;
    hasActiveCardTokens: boolean;
    hasPendingTokens: boolean;
    canOnboardWatch: boolean;
    canOnboardPhone: boolean;
};

export const getApplePayCardStatusTe = (data: ApplePayTeCardData, nativeProps: ReactNativeProps): ApplePayCardStaus => {
    const nativeStatus = getApplePayCardNativeState(data.eligible, nativeProps, data.pendingTokens);

    const canOnboardWatch = !nativeStatus.cardIsInRemoteWallet && !!nativeProps.appleWallet?.isWatchPaired;
    const canOnboardPhone = !nativeStatus.cardIsInLocalWallet;

    return {
        canOnboard: canOnboardPhone || canOnboardWatch,
        hasActiveCardTokens: data.eligible.tokens.some((token) => token.status === 'ACTIVE'),
        hasPendingTokens: !!nativeStatus.pendingDeviceTokens && nativeStatus.pendingDeviceTokens.length > 0,
        canOnboardWatch,
        canOnboardPhone,
    };
};

export const getApplePayCardStatusKb = (data: ApplePayKbCardData, nativeProps: ReactNativeProps): ApplePayCardStaus => {
    const nativeStatus = getApplePayCardNativeStateKb(data.eligibleCard, nativeProps);

    const canOnboardWatch = !nativeStatus.cardIsInRemoteWallet && !!nativeProps.appleWallet?.isWatchPaired;
    const canOnboardPhone = !nativeStatus.cardIsInLocalWallet;

    const result = {
        canOnboard: canOnboardPhone || canOnboardWatch,
        hasActiveCardTokens: data.eligibleCard.tokens.some((token) => token.status === 'ACTIVE'),
        hasPendingTokens: !!nativeStatus.pendingDeviceTokens && nativeStatus.pendingDeviceTokens.length > 0,
        canOnboardWatch,
        canOnboardPhone,
    };

    Logger.info('wallet', 'AppleWalletKB info log', 'getApplePayCardStatusKb', {
        data: {
            ...result,
            eligible: data.eligibleCard,
            nativeStatus,
            nativeAppleWallet: nativeProps.appleWallet,
        },
    });

    return result;
};
